module.exports = __webpack_public_path__ + "static/img/superhero_02.aad7efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/video/superhero_02.png
// module id = n0vx
// module chunks = 0